import { FallbackImage } from '@/components/ui/FallbackImage';
import { getEventMapImage } from '@/lib/images';
import { uiFb } from '@/lib/i18n';

interface EventMapImageProps {
  eventGroup: string;
  title: string;
  lang?: string;
}

export function EventMapImage({ eventGroup, title, lang }: EventMapImageProps) {
  return (
    <div className="overflow-hidden rounded-lg border border-border-subtle">
      <FallbackImage
        src={getEventMapImage(eventGroup)}
        alt={uiFb('ui.detail.map_alt', `Map showing ${title} date variation by country`, lang, { title })}
        width={1200}
        height={600}
        className="w-full"
        sizes="(max-width: 768px) 100vw, 1200px"
        unoptimized
      />
    </div>
  );
}
